import axios from "axios";
import { ICardElementWithChildren } from "backend/model/model";
import { useQuery } from "react-query";

const useScorecardHierarchy = (modelId: string) => {
  const addChildren = (parent: ICardElementWithChildren, hierarchy: any[]) => {
    const childObjects = hierarchy.filter(
      (el: any) => el.parent_element_id === parent.id
    );
    parent.children = childObjects;
    for (let i = 0; i < parent.children.length; i += 1)
      addChildren(parent.children[i], hierarchy);
  };

  return useQuery<ICardElementWithChildren[]>(
    "use-scorecardHierarchy",
    async () => {
      const response = await axios.post("meaquery", {
        query: `@result=[SC.${modelId}].scorecard; @result+=@result.topelement; @result;`,
        attributes: `name,typename,symbol,parentobjects(as="parent_element_id"),topelement,scorecardid,value(series="JS_ATTR",period="latestforseries",as="JS_ATTR")`,
      });

      const result = response.data?.data.map((el: any) => {
        return { ...el };
      });

      let rootSC: any = undefined;
      const filtered = result.filter(
        (el: any) =>
          (el.symbol === "L0" || el.parent_element_id !== "") &&
          el.name &&
          el.typename === "Scorecard"
      );

      const hierarchy = response.data?.data
        .filter(
          (el: any) =>
            (el.symbol === "L0" || el.parent_element_id !== "") &&
            el.name &&
            el.typename === "Scorecard"
        )
        .map((sc: any) => {
          if (sc.symbol === "L0") rootSC = sc;
          // read JS_ATTR from topelement
          const topelement = result.find(
            (el: any) =>
              el.typename !== "Scorecard" && el.scorecardid === sc.scorecardid
          );
          sc.JS_ATTR = topelement.JS_ATTR;
          delete sc.scorecardid;
          sc.children = [];
          return sc;
        });

      if (!rootSC) return [];

      addChildren(rootSC, hierarchy);

      return [rootSC] as ICardElementWithChildren[];
    },
    {
      enabled: true,
      staleTime: 10 * 60 * 1000, // cache for ten minutes
      cacheTime: 10 * 60 * 1000,
    }
  );
};

export default useScorecardHierarchy;
